module.exports = __webpack_public_path__ + "img/productIMG.9d9b4a65.png";